import { format, isValid, parseISO } from "date-fns";
import { getDateFnsLocale } from "@/i18n/dateLocale";

/** Display-only search dates. ISO calendar days remain unchanged for filters and URLs. */
export function formatSearchDay(value: string, language?: string, includeYear = true): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
  const date = parseISO(value);
  if (!isValid(date) || format(date, "yyyy-MM-dd") !== value) return "";
  const locale = getDateFnsLocale(language);
  return `${format(date, "d MMM", { locale })}${includeYear ? ` ${format(date, "yyyy")}` : ""}`;
}

export function formatSearchRange(from?: string | null, to?: string | null, language?: string): string {
  const first = from && formatSearchDay(from, language);
  const last = to && formatSearchDay(to, language);
  if (first && last) {
    if (from === to) return first;
    const sameYear = from!.slice(0, 4) === to!.slice(0, 4);
    return `${sameYear ? formatSearchDay(from!, language, false) : first} – ${last}`;
  }
  if (first) return `${first} – …`;
  return last || "";
}